import db from '../../config/databases/forms';

export default async function getFormUpdatedAt(formId) {
  const form = await db.forms.get(parseInt(formId, 10));
  if (form.updatedAt !== undefined) return form.updatedAt;
  return null;
}
